// Read off `window` through a local cast rather than a `declare global` augmentation: the host app
// declares its own, stricter `Window.dataLayer` and a published module must not clash with it.
type WindowWithDataLayer = { dataLayer?: unknown[] };

export function trackEvent(
  eventName: string,
  eventData: Record<string, unknown> = {},
  dataLayer: unknown[] | undefined,
) {
  const defaultDataLayer = () => {
    if (typeof window !== 'undefined') {
      const globalWindow = window as unknown as WindowWithDataLayer;
      globalWindow.dataLayer = globalWindow.dataLayer || [];
      return globalWindow.dataLayer;
    }
  };
  const activeDataLayer = dataLayer || defaultDataLayer();
  if (activeDataLayer) {
    activeDataLayer.push({
      event: eventName,
      ...eventData,
    });
  }
}
